import ConfirmModal from '@c/modals/ConfirmModal';
import VariationSelector from '@c/products/VariationSelector';
import Button from '@ui/Button';
import { deleteListing } from '@util/firestore/products';
import { ProductDocument } from 'models/product';
import { useAuth } from 'context/AuthContext';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

const SellerActionButtons = ({ product }: { product: ProductDocument }) => {
  const { userDoc } = useAuth();
  const [openModal, setOpenModal] = useState(false);
  const router = useRouter();
  const uniqueSizes =
    Array.from(
      new Set(
        product.variations?.map((v) => v.size).filter((size) => size !== 'N/A')
      )
    ) ?? [];
  const uniqueColors =
    Array.from(new Set(product.variations?.map((v) => v.color))) ?? [];
  return (
    <div className="flex flex-col gap-[1.6rem]">
      <div className="flex flex-col gap-[1.6rem] xl:flex-row">
        <Button
          width="fluid"
          type="tertiary"
          text="Edit Listing"
          href={`/edit-listing/${product.id}`}
        />

        <Button
          width="fluid"
          type="decline"
          text="Delete Listing"
          onClick={() => setOpenModal(true)}
        />
      </div>
      {openModal && (
        <ConfirmModal
          title="Delete Listing"
          body="Are you sure you want to delete this listing?"
          buttonText="Delete"
          isOpen={openModal}
          dismiss={(confirm) => {
            if (confirm)
              deleteListing(product.id).then(() => {
                if (!userDoc?.roles?.support)
                  router.push('/dashboard/listings');
                else router.refresh();
              });
            else setOpenModal(false);
          }}
        />
      )}
    </div>
  );
};

export default SellerActionButtons;
